import createStore from './createStore';

const initialState = {};
const trpSiteCatalystData = {
  productType: '', // string
  accountType: '', // string
  // "id":              // string
  // "quantity":        // number
  // "amount":          // number
};
const store = createStore(initialState, trpSiteCatalystData);

// Any module can ask for the store.
export default store;
